import { ISoftDeletablePaginationParameters } from '../interfaces/pagination-parameters.interface';

export const defaultPaginationParameters: ISoftDeletablePaginationParameters = {
  isActive: true
};

export const defaultListPaginationParameters: ISoftDeletablePaginationParameters = {};
